// @flow
import { createSelector } from 'reselect';

import { List } from 'immutable';
import type { RecordOf } from 'immutable';

import { REDUCER_KEY } from './reducer';
import type { InstitutionsStore } from './types';

export const getInstitutionStore = (state: any): InstitutionsStore => state[REDUCER_KEY];
export const getInstitutionsById = (state: any) => getInstitutionStore(state).resourcesById;
export const getPopularInstitutionIds = (state: any) => getInstitutionStore(state).popularIds;

export const getInstitution = (state: any, id: string) => {
  const institutionsById = getInstitutionsById(state);
  return institutionsById.get(id);
};

type InstitutionLoginAggregatorProps = {
  channel: ?string,

  aggStatus: ?string,
  aggStatusCode: ?string,
  aggStatusDetail: ?string,

  lastStatusUpdatedAt: ?string,

  lastRefreshSuccessfulAt: ?string,
  lastRefreshAttemptedAt: ?string,
}
export type InstitutionLoginAggregator = RecordOf<InstitutionLoginAggregatorProps>;

export const getPopularInstitutions = createSelector(
  getInstitutionsById,
  getPopularInstitutionIds,
  (institutionsById, popularIds) => {
    if (!popularIds) {
      return null;
    }
    const popularInstitutions = popularIds.reduce((list, id) => {
      const institution = institutionsById.get(id);
      if (institution && institution.logoUrl) {
        list.push(institution);
      }
      return list;
    }, []);
    if (popularInstitutions.length === 0) {
      return null;
    }
    return List(popularInstitutions);
  }
);
